// extracted by mini-css-extract-plugin
module.exports = {"owu2orl":"owu2orl","s1ildd3l":"s1ildd3l","w1a877nv":"w1a877nv","s4uteva":"s4uteva","a1rqk0u8":"a1rqk0u8"};